/**
 * Shopify Cart Quantity Limiter for 'limit-1' and 'limit-2' Tagged Products
 *
 * - limit-1: max 1 per product
 * - limit-2: max 2 per product
 */

const LIMIT_TAGS = { 'limit-1': 1, 'limit-2': 2 };
const LIMIT_TAG_NAMES = Object.keys(LIMIT_TAGS);
const DEBUG = false;
var originalFetch = window.fetch.bind(window);

function log() {
  if (DEBUG && typeof console !== 'undefined') {
    console.log.apply(console, ['[Cart Limiter]'].concat([].slice.call(arguments)));
  }
}

if (typeof window.productTags === 'undefined') {
  window.productTags = {};
}

function getLimitFromTags(tags) {
  if (!tags || !Array.isArray(tags)) return null;
  for (var i = 0; i < LIMIT_TAG_NAMES.length; i++) {
    var tag = LIMIT_TAG_NAMES[i];
    if (tags.indexOf(tag) !== -1) return LIMIT_TAGS[tag];
  }
  return null;
}

// Store product limit (max quantity) per product_id. null = checked, no limit.
var productLimitCache = {};
var qtyByProductId = {};
var enforceInFlight = false;
var enforceQueued = false;

function seedLimitCacheFromDom() {
  document.querySelectorAll('[data-product-id][data-product-limit]').forEach(function (el) {
    var id = el.getAttribute('data-product-id');
    var limit = parseInt(el.getAttribute('data-product-limit'), 10);
    if (id && !isNaN(limit) && limit > 0 && productLimitCache[id] === undefined) {
      productLimitCache[id] = limit;
    }
  });
}

function refreshMinicart() {
  var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_url) ? theme.routes.cart_url : '/cart';
  var root = (typeof theme !== 'undefined' && theme.routes && theme.routes.root != null && theme.routes.root !== '')
    ? theme.routes.root
    : '/';
  var base = root.replace(/\/?$/, '') || '/';
  var url = base + '?sections=header';

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data || !data.header) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(data.header, 'text/html');
      var newHeaderCart = doc.querySelector('.header-cart');
      if (!newHeaderCart) return;
      ['.page-header .header-cart', '.docked-navigation-container .header-cart'].forEach(function (sel) {
        var curr = document.querySelector(sel);
        if (curr && curr.parentNode) {
          curr.parentNode.replaceChild(newHeaderCart.cloneNode(true), curr);
        }
      });
      var wrap = document.createElement('div');
      wrap.innerHTML = data.header;
      var countEl = wrap.querySelector('[data-cart-count], .header-cart__count');
      var newCount = countEl ? countEl.textContent.trim() : null;
      if (newCount != null) {
        document.querySelectorAll('[data-cart-count], .header-cart__count').forEach(function (el) {
          el.textContent = newCount;
          if (el.setAttribute) el.setAttribute('data-cart-count', newCount);
        });
      }
    })
    .catch(function () {});
}

async function resolveProductLimit(item) {
  var cached = productLimitCache[item.product_id];
  if (cached !== undefined) return cached;

  if (item.tags && Array.isArray(item.tags)) {
    var fromItemTags = getLimitFromTags(item.tags);
    productLimitCache[item.product_id] = fromItemTags;
    return fromItemTags;
  }

  if (item.handle) {
    try {
      var productResponse = await fetch('/products/' + item.handle + '.js');
      if (productResponse.ok) {
        var product = await productResponse.json();
        var fromProduct = getLimitFromTags(product.tags);
        productLimitCache[item.product_id] = fromProduct;
        return fromProduct;
      }
    } catch (e) {
      console.warn('Cart limiter: could not fetch product by handle', e);
    }
  }

  productLimitCache[item.product_id] = null;
  return null;
}

function isSoldOutAddButton(btn) {
  if (!btn) return false;
  if (btn.classList.contains('quick-add-btn') && !btn.hasAttribute('data-add-to-cart')) return true;
  var root = btn.closest('form, .product-detail, .quickbuy-form');
  if (root && root.classList.contains('variant--unavailable')) return true;
  return false;
}

function meaningfulProperties(props) {
  var out = {};
  if (!props) return out;
  Object.keys(props).forEach(function (key) {
    if (!key || key.charAt(0) === '_') return;
    var val = props[key];
    if (val == null || String(val).trim() === '') return;
    out[key] = String(val).trim();
  });
  return out;
}

function propertiesMatch(a, b) {
  a = meaningfulProperties(a);
  b = meaningfulProperties(b);
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  for (var i = 0; i < keysA.length; i++) {
    if (a[keysA[i]] !== b[keysA[i]]) return false;
  }
  return true;
}

window.buildCartAddPayloadFromForm = function (form) {
  var data = new FormData(form);
  var id = null;
  var quantity = 1;
  var properties = {};
  data.forEach(function (value, key) {
    if (key === 'id') {
      id = value;
    } else if (key === 'quantity') {
      quantity = parseInt(value, 10) || 1;
    } else if (key.indexOf('properties[') === 0) {
      var name = key.slice(11, key.charAt(key.length - 1) === ']' ? -1 : key.length);
      if (name && name.charAt(0) !== '_' && String(value).trim() !== '') {
        properties[name] = String(value).trim();
      }
    }
  });
  var payload = { id: Number(id), quantity: quantity };
  if (Object.keys(properties).length) payload.properties = properties;
  return payload;
};

window.findMatchingCartLine = function (items, variantId, properties) {
  variantId = String(variantId);
  for (var i = 0; i < (items || []).length; i++) {
    var item = items[i];
    var itemVid = String(item.variant_id || item.id);
    if (itemVid !== variantId) continue;
    if (propertiesMatch(item.properties, properties || {})) return item;
  }
  return null;
};

function limitReachedText(limit) {
  return limit === 1 ? 'הפריט כבר נמצא בעגלה' : 'הגעת למכסה המקסימלית (' + limit + ' פריטים)';
}

window.cartLimitReachedText = limitReachedText;

window.isProductAtCartLimit = function (productId, limit) {
  if (!productId || !limit) return false;
  return (qtyByProductId[String(productId)] || 0) >= limit;
};

window.qtyOfProductInCart = function (items, productId) {
  var qty = 0;
  (items || []).forEach(function (item) {
    if (String(item.product_id) === String(productId)) qty += item.quantity;
  });
  return qty;
};

window.remainingLimitedQty = function (items, productId, limit) {
  if (!productId || !limit) return Infinity;
  return Math.max(0, limit - window.qtyOfProductInCart(items, productId));
};

function lineQtyFromWrap(wrap) {
  var input = wrap.querySelector('input.quantity__number');
  if (input) {
    var n = parseInt(input.value, 10);
    return isNaN(n) ? 0 : n;
  }
  var display = wrap.querySelector('.quantity__number');
  var shown = parseInt((display && display.textContent) || '0', 10);
  return isNaN(shown) ? 0 : shown;
}

function syncCartLineLimits() {
  var groups = {};
  document.querySelectorAll('.quantity__change[data-product-id][data-product-limit]').forEach(function (wrap) {
    var id = String(wrap.getAttribute('data-product-id'));
    var limit = parseInt(wrap.getAttribute('data-product-limit'), 10);
    if (!id || !limit) return;
    if (!groups[id]) groups[id] = { limit: limit, wraps: [] };
    groups[id].wraps.push(wrap);
  });

  Object.keys(groups).forEach(function (id) {
    var group = groups[id];
    var total = 0;
    group.wraps.forEach(function (wrap) {
      total += lineQtyFromWrap(wrap);
    });
    qtyByProductId[id] = total;
    group.wraps.forEach(function (wrap) {
      var input = wrap.querySelector('input.quantity__number');
      var plus = wrap.querySelector('.quantity__plus');
      var lineQty = lineQtyFromWrap(wrap);
      var lineMax = group.limit - (total - lineQty);
      if (lineMax < 1) lineMax = Math.max(lineQty, 1);
      if (input) input.setAttribute('data-max', String(lineMax));
      if (plus) {
        if (total >= group.limit) plus.classList.add('quantity__unusable');
        else plus.classList.remove('quantity__unusable');
      }
    });
  });
}

window.canAddLimitedProduct = async function (productId, limit, addQty) {
  addQty = addQty || 1;
  if (!productId || !limit) return true;
  try {
    var res = await originalFetch('/cart.js');
    var cart = await res.json();
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      if (String(item.product_id) === String(productId)) {
        qty += item.quantity;
      }
    });
    qtyByProductId[String(productId)] = qty;
    productLimitCache[String(productId)] = limit;
    if (qty + addQty > limit) {
      syncLimitButtons(true);
      return false;
    }
    return true;
  } catch (e) {
    var cachedQty = qtyByProductId[String(productId)] || 0;
    if (cachedQty + addQty > limit) {
      syncLimitButtons(true);
      return false;
    }
    return true;
  }
};

window.noteLimitedCartAdd = function (productId, addQty, limit) {
  if (!productId) return;
  var id = String(productId);
  var qty = addQty == null ? 1 : addQty;
  qtyByProductId[id] = (qtyByProductId[id] || 0) + qty;
  if (limit) productLimitCache[id] = limit;
  try {
    syncLimitButtons(true);
  } catch (e) {}
};

function applyLimitToButton(btn, atLimit, limit) {
  if (!btn || isSoldOutAddButton(btn)) return;
  if (btn.closest && btn.closest('form.add-in-progress')) return;

  var textEl = btn.querySelector('[data-add-to-cart-text]');
  if (!textEl && (btn.classList.contains('add-to-cart-button') || btn.classList.contains('quickbuy__submit'))) {
    textEl = document.createElement('span');
    textEl.setAttribute('data-add-to-cart-text', '');
    btn.textContent = '';
    btn.appendChild(textEl);
  }
  var addLabel = btn.getAttribute('data-add-label');

  if (atLimit) {
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-label', limitReachedText(limit));
    if (textEl) {
      textEl.textContent = limitReachedText(limit);
    }
  } else {
    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    if (btn.classList.contains('quick-add-btn')) {
      btn.setAttribute('aria-label', 'הוסף לסל');
    } else if (addLabel) {
      btn.setAttribute('aria-label', addLabel);
    }
    if (textEl && addLabel) {
      textEl.textContent = addLabel;
    }
  }
}

async function syncLimitButtons(useCachedQty) {
  seedLimitCacheFromDom();
  var nodes = document.querySelectorAll('[data-product-id][data-product-limit]');
  if (!nodes.length) {
    syncCartLineLimits();
    return;
  }

  try {
    if (!useCachedQty || !Object.keys(qtyByProductId).length) {
      var res = await originalFetch('/cart.js');
      var cart = await res.json();
      qtyByProductId = {};
      (cart.items || []).forEach(function (item) {
        var id = String(item.product_id);
        qtyByProductId[id] = (qtyByProductId[id] || 0) + item.quantity;
      });
    }

    var seenButtons = [];
    nodes.forEach(function (el) {
      var productId = el.getAttribute('data-product-id');
      var limit = parseInt(el.getAttribute('data-product-limit'), 10);
      if (!productId || !limit) return;
      var qty = qtyByProductId[String(productId)] || 0;
      var atLimit = qty >= limit;

      var buttons = [];
      if (el.matches('button, [data-add-to-cart], .quick-add-btn')) {
        buttons.push(el);
      }
      el.querySelectorAll('button[data-add-to-cart], .quick-add-btn').forEach(function (btn) {
        var btnProductId = btn.getAttribute('data-product-id');
        if (btnProductId && String(btnProductId) !== String(productId)) return;
        buttons.push(btn);
      });

      buttons.forEach(function (btn) {
        if (seenButtons.indexOf(btn) !== -1) return;
        seenButtons.push(btn);
        applyLimitToButton(btn, atLimit, limit);
      });

      var msgEl = el.querySelector ? el.querySelector('[data-limit-message]') : null;
      if (msgEl) {
        msgEl.style.display = atLimit ? '' : 'none';
      }
    });
    syncCartLineLimits();
  } catch (e) {
    console.warn('Cart limiter: could not update limit buttons', e);
  }
}

window.updateCartLimitButtons = function () {
  return syncLimitButtons(false);
};

function cartLineHasMergeSensitiveData(item) {
  if (item.selling_plan_allocation || item.selling_plan) return true;
  if (item.item_components && item.item_components.length) return true;
  if (item.parent_relationship) return true;
  var allocationFields = ['discounts', 'discount_allocations', 'line_level_discount_allocations'];
  for (var i = 0; i < allocationFields.length; i++) {
    var allocations = item[allocationFields[i]];
    if (allocations && Object.keys(allocations).length) return true;
  }
  if (Number(item.total_discount) > 0 || Number(item.line_level_total_discount) > 0) return true;
  if (item.original_price != null && item.final_price != null && Number(item.original_price) !== Number(item.final_price)) return true;
  if (item.original_line_price != null && item.final_line_price != null && Number(item.original_line_price) !== Number(item.final_line_price)) return true;
  if (item.price != null && item.discounted_price != null && Number(item.price) !== Number(item.discounted_price)) return true;
  return false;
}

function cartLinesSafeToMerge(group) {
  var first = group[0];
  var firstProps = first.properties || {};
  var firstKeys = Object.keys(firstProps).sort();
  for (var i = 0; i < group.length; i++) {
    var item = group[i];
    if (!item.key || cartLineHasMergeSensitiveData(item)) return false;
    if (String(item.product_id) !== String(first.product_id)) return false;
    var priceFields = ['price', 'original_price', 'final_price', 'discounted_price'];
    for (var p = 0; p < priceFields.length; p++) {
      var field = priceFields[p];
      if (item[field] !== first[field]) return false;
    }
    var props = item.properties || {};
    var keys = Object.keys(props).sort();
    if (keys.length !== firstKeys.length) return false;
    for (var k = 0; k < keys.length; k++) {
      if (keys[k] !== firstKeys[k] || props[keys[k]] !== firstProps[firstKeys[k]]) return false;
    }
  }
  return true;
}

async function enforceCartLimits() {
  if (enforceInFlight) {
    enforceQueued = true;
    return;
  }
  enforceInFlight = true;
  seedLimitCacheFromDom();

  try {
    var response = await originalFetch('/cart.js');
    var cart = await response.json();
    qtyByProductId = {};
    (cart.items || []).forEach(function (item) {
      var id = String(item.product_id);
      qtyByProductId[id] = (qtyByProductId[id] || 0) + item.quantity;
    });

    var updates = {};
    var updateNeeded = false;
    var items = cart.items.slice();

    for (var i = items.length - 1; i >= 0; i--) {
      var item = items[i];
      var maxQty = await resolveProductLimit(item);
      if (maxQty == null) continue;
      var id = String(item.product_id);
      var total = qtyByProductId[id] || 0;
      if (total <= maxQty) continue;
      var excess = total - maxQty;
      var reduceBy = Math.min(item.quantity, excess);
      var newQty = item.quantity - reduceBy;
      updates[String(item.key || item.id)] = newQty;
      qtyByProductId[id] = total - reduceBy;
      updateNeeded = true;
    }

    var variantGroups = {};
    items.forEach(function (item) {
      var vid = String(item.variant_id || item.id);
      if (!variantGroups[vid]) variantGroups[vid] = [];
      variantGroups[vid].push(item);
    });
    Object.keys(variantGroups).forEach(function (vid) {
      var group = variantGroups[vid];
      if (group.length < 2) return;
      if (!cartLinesSafeToMerge(group)) return;
      var maxQty = productLimitCache[group[0].product_id];
      var total = 0;
      group.forEach(function (it) {
        var k = String(it.key || it.id);
        total += (updates[k] != null ? updates[k] : it.quantity);
      });
      if (maxQty) total = Math.min(total, maxQty);
      var keepKey = String(group[0].key || group[0].id);
      if ((updates[keepKey] != null ? updates[keepKey] : group[0].quantity) !== total) {
        updates[keepKey] = total;
        updateNeeded = true;
      }
      for (var j = 1; j < group.length; j++) {
        var extraKey = String(group[j].key || group[j].id);
        if ((updates[extraKey] != null ? updates[extraKey] : group[j].quantity) !== 0) {
          updates[extraKey] = 0;
          updateNeeded = true;
        }
      }
    });

    if (updateNeeded) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      refreshMinicart();
    }

    await syncLimitButtons(true);
    syncCartLineLimits();
  } catch (error) {
    console.error('Error enforcing cart limits:', error);
  } finally {
    enforceInFlight = false;
    if (enforceQueued) {
      enforceQueued = false;
      setTimeout(enforceCartLimits, 50);
    }
  }
}

function scheduleEnforceAfterMutation() {
  setTimeout(function () {
    enforceCartLimits();
  }, 100);
}

function capCartQuantityInput(input) {
  var max = input.getAttribute('data-max');
  if (max == null) return;
  var maxNum = parseInt(max, 10);
  if (isNaN(maxNum) || maxNum < 1) return;
  var val = parseInt(input.value, 10);
  if (isNaN(val) || val < 0) val = 0;
  if (val > maxNum) {
    input.value = maxNum;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

document.addEventListener('DOMContentLoaded', function () {
  seedLimitCacheFromDom();
  enforceCartLimits();

  document.addEventListener('click', function (e) {
    var plus = e.target && e.target.closest && e.target.closest('.quantity__plus');
    if (!plus) return;
    var wrap = plus.closest('.quantity__change');
    if (!wrap) return;
    var productId = wrap.getAttribute('data-product-id');
    var limit = parseInt(wrap.getAttribute('data-product-limit'), 10);
    if (!productId || !limit) return;
    var total = 0;
    document.querySelectorAll('.quantity__change[data-product-id="' + productId + '"]').forEach(function (row) {
      total += lineQtyFromWrap(row);
    });
    if (total >= limit) {
      e.preventDefault();
      e.stopImmediatePropagation();
      plus.classList.add('quantity__unusable');
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input.quantity__number')) {
      capCartQuantityInput(e.target);
    }
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.target.matches && e.target.matches('input.quantity__number')) {
      capCartQuantityInput(e.target);
    }
  }, true);

  var cartForm = document.querySelector('form.limoniapps-discountninja-cart-root, .cart form[action*="cart"]');
  if (cartForm) {
    cartForm.addEventListener('submit', function () {
      cartForm.querySelectorAll('input.quantity__number[data-max]').forEach(capCartQuantityInput);
    }, true);
  }

  document.addEventListener('cart:updated', scheduleEnforceAfterMutation);
  document.addEventListener('cart.requestComplete', scheduleEnforceAfterMutation);
  document.addEventListener('theme:cart:change', scheduleEnforceAfterMutation);
  document.addEventListener('product:added', scheduleEnforceAfterMutation);
  document.addEventListener('product_added', scheduleEnforceAfterMutation);
  document.addEventListener('added.ajaxProduct', scheduleEnforceAfterMutation);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.js-quickbuy-button')) {
      setTimeout(function () { syncLimitButtons(false); }, 400);
    }
  });

  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document).on('variantChange', function () {
      syncLimitButtons(true);
    });
    window.jQuery(document).on('cbox_complete', function () {
      if (document.querySelector('#colorbox .quickbuy-form[data-product-limit], .quickbuy-form[data-product-limit]')) {
        syncLimitButtons(false);
      }
    });
  }

  // Fast header refresh after add: sections API instead of full search page
  if (typeof window.jQuery !== 'undefined' && typeof theme !== 'undefined' && theme.routes) {
    var searchUrl = theme.routes.search_url;
    var originalGet = window.jQuery.get;
    window.jQuery.get = function (url, data, callback, dataType) {
      if (typeof data === 'function') {
        callback = data;
        data = undefined;
      }
      if (url === searchUrl && typeof callback === 'function') {
        var root = (theme.routes.root != null && theme.routes.root !== '') ? theme.routes.root : '/';
        var base = root.replace(/\/?$/, '') || '/';
        var sectionsUrl = base + '?sections=header';
        fetch(sectionsUrl)
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var html = (json && json.header) ? json.header : '';
            callback(html);
            var wrap = document.createElement('div');
            wrap.innerHTML = html;
            var countEl = wrap.querySelector('[data-cart-count], .header-cart__count');
            var newCount = countEl ? countEl.textContent.trim() : null;
            if (newCount != null) {
              document.querySelectorAll('[data-cart-count], .header-cart__count').forEach(function (el) {
                el.textContent = newCount;
              });
            }
          })
          .catch(function () { originalGet(url, data, callback, dataType); });
        return;
      }
      return originalGet.apply(this, arguments);
    };
  }

  if (typeof window.jQuery !== 'undefined') {
    var $ = window.jQuery;
    $.ajaxPrefilter(function (options) {
      if (!options.url || options.url.indexOf('/cart/add') === -1 || !options.data) return;
      var data = options.data;
      if (typeof data === 'string') {
        var params = new URLSearchParams(data);
        if (params.has('limit_product_id')) {
          params.delete('limit_product_id');
          params.delete('limit_max');
          options.data = params.toString();
        }
      } else if (typeof data === 'object' && data !== null && data.limit_product_id) {
        var newData = {};
        for (var key in data) {
          if (key !== 'limit_product_id' && key !== 'limit_max') newData[key] = data[key];
        }
        options.data = newData;
      }
    });
    $(document).ajaxComplete(function (event, xhr, settings) {
      if (settings.url && settings.url.indexOf('/cart/add') !== -1 && xhr.status >= 200 && xhr.status < 300) {
        scheduleEnforceAfterMutation();
      }
    });
  }
});

// Only react to cart *mutations* — never to plain GET /cart.js (that caused a request loop)
window.fetch = function (url, options) {
  var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
  var method = ((options && options.method) || 'GET').toUpperCase();
  var isAdd = urlStr.indexOf('/cart/add') !== -1;
  var isUpdate = urlStr.indexOf('/cart/update') !== -1 || urlStr.indexOf('/cart/change') !== -1;
  var isMutation = isAdd || isUpdate || (method !== 'GET' && urlStr.indexOf('/cart') !== -1);

  return originalFetch.apply(this, arguments).then(function (response) {
    if (isMutation && response && response.ok) {
      scheduleEnforceAfterMutation();
    }
    return response;
  });
};
